export default function NukeRequest({ children }) {
    return <a href="/oh-requests" className="btn btn-outline-primary">{children}</a>
}